module.exports = __webpack_public_path__ + "img/Jedrzej.0ee6e48b.jpg";